<template>
  <div class="hospitals">
    <img class="hospitalsImg" src="@/assets/hospitals.png" alt />
    <div class="hospitalsMask">
      <!-- <van-icon class="hospiyalsArrowLeft" name="arrow-left" @click="onBack" /> -->
      <button class="changeThe" @click="onChangeThe">更改医院</button>
      <!-- <span class="hospitalsName" v-if="value">{{value}}</span> -->
      <span class="hospitalsName">{{hospitalsInfo.name}}</span>
      <span class="system">影像检查数字化报告/影像系统</span>
    </div>
  </div>
</template>
<script>
import Storage from '@/tools/storage'
export default {
  name: 'hospitals',
  props: ['hospitalsInfo'],
  data() {
    return {
      // value: Storage.get('value')
    }
  },
  methods: {
    onChangeThe() {
      this.$router.push({ path: 'findHospital' })
    },
    onBack() {
      if (Storage.get('bind') == 2) {
        this.$router.push({ path: '/checkInfo' })
      } else {
        this.$router.push({ path: '/select' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>

